var map = {
	"./": 3103,
	"./DiffChart": 9249,
	"./DiffChart.tsx": 9249,
	"./DiffStar": 5153,
	"./DiffStar.tsx": 5153,
	"./IHTSmallLogo": 7272,
	"./IHTSmallLogo.tsx": 7272,
	"./IPSmallLogo": 7676,
	"./IPSmallLogo.tsx": 7676,
	"./IRSmallLogo": 9180,
	"./IRSmallLogo.tsx": 9180,
	"./MenuCloseIcon": 7050,
	"./MenuCloseIcon.ts": 7050,
	"./MenuOpenIcon": 7499,
	"./MenuOpenIcon.ts": 7499,
	"./SectionLineIcon": 2096,
	"./SectionLineIcon.tsx": 2096,
	"./index": 3103,
	"./index.tsx": 3103
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = 4480;
module.exports = webpackContext;